import React from "react";
import { Route, Switch } from "react-router";

import SignIn from "./containers/SignIn";
import Layout from "./containers/Layout";
import Authorization from "./containers/Authorization";

import App from "./containers/App";
import Parameters from "./containers/Parameters";
import NuevaSolicitud from "./containers/NuevaSolicitud";
import Cencos from "./containers/Cencos";
import Usuarios from "./containers/Usuarios";
import TipoServicios from "./containers/TipoServicios";
import Solicitudes from "./containers/Solicitudes";
import Solicitud from "./containers/Solicitud";
import Reporte1 from "./containers/Reporte1";
import Reporte2 from "./containers/Reporte2";
import CasosNoAutorizados from './containers/CasosNoAutorizados/CasosNoAutorizados'
import InterfazContable from "./containers/InterfazContable";
import Plantillas from "./containers/Plantillas";

import Error401 from "./containers/Error401";
import Error404 from "./containers/Error404";

const prefix = window.FOLDER;

export default (
  <Switch>
    <Route exact path={`${prefix}/signin`} component={SignIn} />
    <Layout>
      <Switch>
        <Route exact path={`${prefix}/`} component={Authorization(App)} />
        <Route
          exact
          path={`${prefix}/parametros`}
          component={Authorization(Parameters)}
        />
        <Route
          exact
          path={`${prefix}/solicitudes/nueva`}
          component={Authorization(NuevaSolicitud)}
        />
        <Route
          exact
          path={`${prefix}/cencos`}
          component={Authorization(Cencos)}
        />
        <Route
          exact
          path={`${prefix}/usuarios`}
          component={Authorization(Usuarios)}
        />
        <Route
          exact
          path={`${prefix}/tipos_servicio`}
          component={Authorization(TipoServicios)}
        />
        <Route
          exact
          path={`${prefix}/solicitudes`}
          component={Authorization(Solicitudes)}
        />
        <Route
          exact
          path={`${prefix}/solicitudes/:id`}
          component={Authorization(Solicitud)}
        />
        <Route
          exact
          path={`${prefix}/reportes/solicitudes-aprobadas`}
          component={Authorization(Reporte1)}
        />
        <Route
          exact
          path={`${prefix}/reportes/compras-cafeteria`}
          component={Authorization(Reporte2)}
        />
        <Route
          exact
          path={`${prefix}/reportes/casos-no-autorizados-a-tiempo`}
          component={Authorization(CasosNoAutorizados)}
        />
        <Route
          exact
          path={`${prefix}/reportes/interfaz-contable`}
          component={Authorization(InterfazContable)}
        />
        <Route
          exact
          path={`${prefix}/plantillas`}
          component={Authorization(Plantillas)}
        />
        <Route path={`${prefix}/unauthorized`} component={Error401} />
        <Route component={Error404} />
      </Switch>
    </Layout>
  </Switch>
);
